var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"svg-icon",class:[_vm.customClass],style:(_setup.customStyle),on:{"click":_setup.handleClick}},[(_vm.icon)?_c(_vm.icon,{tag:"component"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }